import {UseStorageOptions} from "@mantine/hooks";
import {TimeClockNotificationsFrequency} from "@/types/enums/TimeClockNotificationsFrequency.ts";

export const MANTINE_DATETIME_FORMAT = "yyyy-MM-dd HH:mm:ss"
export const TIME_CLOCK_NOTIFICATIONS_FREQUENCY_LOCAL_STORAGE_PROPS: UseStorageOptions<string> & {defaultValue: string} = {
    key: "timeClockNotificationsFrequency",
    defaultValue: TimeClockNotificationsFrequency.NEVER
}
export const LAST_SECURITY_KEY_VERIFICATION_TIMESTAMP_LOCAL_STORAGE_PROPS: UseStorageOptions<string> = {key: "lastSecurityKeyVerificationTimestamp", defaultValue: ""}
export const SCORECARD_FONT_SIZE_LOCAL_STORAGE_PROPS: UseStorageOptions<string> = {key: "scorecardFontSize", defaultValue: "sm"}